class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('[name="country_code"]'),
      button: this.querySelector('[data-localization-trigger]'),
      panel: this.querySelector('[data-localization-panel]'),
    };

    if (!this.elements.button || this.elements.button.getAttribute('aria-disabled') === 'true') {
      return;
    }

    if (this.elements.panel) {
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('[data-localization-option]').forEach((item) => {
        item.addEventListener('mousedown', this.onItemClick.bind(this));
      });
    }
  }

  hidePanel() {
    if (!this.elements.panel) return;
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', '');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    const value = event.currentTarget.dataset.value;
    if (!form || !value || !this.elements.input) return;
    this.elements.input.value = value;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  openSelector(event) {
    event.preventDefault();
    if (!this.elements.panel) return;
    const isHidden = this.elements.panel.hasAttribute('hidden');
    if (isHidden) {
      this.elements.panel.removeAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', 'true');
    } else {
      this.hidePanel();
    }
  }

  closeSelector(event) {
    const related = event.relatedTarget;
    if (related && this.contains(related)) {
      return;
    }
    this.hidePanel();
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
